var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#download_svg__a)",
    fill: "#1C7CE5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.022 13.072c-.76 0-1.472-.294-2.006-.831l-2.21-2.21a.772.772 0 0 1 0-1.075.763.763 0 0 1 .557-.237c.2 0 .39.078.537.215l2.34 2.341-.015-10.003a.774.774 0 0 1 1.55.003l.016 10.016 2.359-2.357.019-.018a.775.775 0 0 1 .537-.22.774.774 0 0 1 .537 1.331l-2.212 2.214a2.833 2.833 0 0 1-2.01.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.087 16.5A2.091 2.091 0 0 1 0 14.412v-3.159a.775.775 0 1 1 1.55 0v3.16c0 .296.244.537.537.54h11.825a.544.544 0 0 0 .541-.537v-3.163a.775.775 0 1 1 1.55 0v3.16c0 1.15-.937 2.087-2.087 2.087H2.087Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDownload;